export default __webpack_public_path__ + "static/media/img_5.ec130902.jpg";